import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import {
  CreateCorporateLeadParams,
  CreateCorporateLeadResponse,
  createCorporateLead,
} from '@utils/backend-api/corporate_lead';

export default function useCorporateLeadCreate(showToast = false) {
  const { mutate, mutateAsync, data, isLoading } = useMutation(
    (params: CreateCorporateLeadParams) => createCorporateLead(params),
    {
      onSuccess: (data: CreateCorporateLeadResponse) => {
        if (showToast) {
          const message = data.existingEntries
            ? 'Thank you for filling out our form. We already have your details and will be reaching out shortly.'
            : 'Thank you for reaching out!. Someone from our team will be in touch with you shortly';
          toast.success(message);
        }
      },
      onError: () => {
        toast.error('There was an error processing your request. Please try again.');
      },
    }
  );

  return { mutate, mutateAsync, data, isLoading };
}
